export const MessengerIcon = ({ className, size = 16 }: { className?: string; size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
  >
    <path d="M12 2C6.36 2 2 6.13 2 11.7c0 2.91 1.2 5.42 3.15 7.2.16.15.26.36.27.58l.05 1.81c.02.64.68 1.06 1.26.8l2.02-.89c.17-.08.36-.1.55-.06.88.24 1.82.37 2.7.37 5.64 0 10-4.13 10-9.7S17.64 2 12 2zm5.95 7.57l-2.91 4.62c-.46.73-1.44.92-2.13.4l-2.31-1.73a.6.6 0 00-.72 0l-3.12 2.37c-.42.32-.96-.18-.68-.63l2.91-4.62c.46-.73 1.44-.92 2.13-.4l2.31 1.73a.6.6 0 00.72 0l3.12-2.37c.42-.32.96.18.68.63z" />
  </svg>
);
